export default "__VITE_ASSET__BN4TFkPg__"